export const assignUser = () => {
  return process.env.REACT_APP_USER_SERVER + "/member/assign_update";
};

const post_api = {
  assignUser,
};

export default post_api;
